module.exports = __webpack_public_path__ + "static/media/aylin_ryder.2a4fa029.jpg";